export const financeKeys = {"HP":"HP","PSA_PCP_ONLY":"PSA_PCP_ONLY","VAUXHALL_PCP_ONLY":"VAUXHALL_PCP_ONLY","DSG_PCP_ONLY":"DSG_PCP_ONLY","PCP":"PCP","OVERAGE_PCP_ONLY":"OVERAGE_PCP_ONLY","PCP_STOCK":"PCP_STOCK","JAFPCP":"JAFPCP","JAFPCP_TELEMATICS":"JAFPCP_TELEMATICS","SIMPLYDRIVE":"SIMPLYDRIVE","SIMPLYDRIVE_TELEMATICS":"SIMPLYDRIVE_TELEMATICS","CONTRACT_HIRE":"CONTRACT_HIRE"};


// WEBPACK FOOTER //
// ./resources/assets/js/modules/json/financeKeys.js